import { Icon } from '../Icon';
import { Stack } from '../Stack';
import { Typography } from '../Typography';
import { styled } from '../styled';
import { useTheme } from '../theme';

export const ArrowFilledDown = () => (
  <Icon.ArrowFilledDown className="table-sort-down" size={16} />
);
export const ArrowFilledUp = () => (
  <Icon.ArrowFilledUp className="table-sort-up" size={16} />
);

const NoRowsOverlayStyled = styled(Stack)(() => ({
  alignItems: 'center',
  justifyContent: 'center',
  padding: '40px 0',
}));

export const NoRowsOverlay = ({
  title,
  text,
}: {
  title?: string;
  text: string;
}) => {
  const { theme } = useTheme();
  return (
    <NoRowsOverlayStyled>
      <Typography color={theme.palette.text.gray} variant="subtitle">
        {title}
      </Typography>
      <Typography color={theme.palette.text.gray}>{text}</Typography>
    </NoRowsOverlayStyled>
  );
};
